// extracted by mini-css-extract-plugin
export default {"banner_box":"index_banner_box_e6M1L","banner":"index_banner_0wJ5-"};